import { LabeledRow } from "@components/LabeledRow";
import { DataKind, FetchCustomerData } from "@customTypes/responses/customer";
import React from "react";
import { emailTypeDictionary } from "../tabs/constants";

type EmailListProps = {
  emails: FetchCustomerData["email"];
};

const EmailList: React.FC<EmailListProps> = ({ emails }) => {
  const typeSet = new Set<DataKind>();
  emails.forEach((email) => typeSet.add(email.typeEnum));
  const emailListByType: FetchCustomerData["email"][] = [];

  typeSet.forEach((type) => {
    emailListByType.push(emails.filter((email) => email.typeEnum == type));
  });

  return (
    <>
      {emailListByType.map((emails) => {
        const type = emails[0].typeEnum;
        const valueList = emails.map((email) => email.address);

        return <LabeledRow key={type} label={emailTypeDictionary[type]} values={valueList} />;
      })}
    </>
  );
};

export default EmailList;
